export default __webpack_public_path__ + "cbd96575a9e27841bc44ac54990a633d.png";